import {set} from 'date-fns';

const now = new Date();

export const getTodayAtSpecificHour = (hour = 12, minutes = 0, seconds = 0) =>
  set(now, {hours: hour, minutes: minutes, seconds: seconds, milliseconds: 0});


